/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.DataList";
        const DEFAULT_ICON_CLOSED = "wpt-font wpt-font-icon_Right";
        const DEFAULT_ICON_OPENED = "wpt-font wpt-font-icon_Down";
        const ROOT_CLASS = "data-list-root";
        const ITEM_CLASS = "data-list-item";
        const SUBLIST_CLASS = "data-list-sublist";
        const ITEM_NAME_CLASS = "data-list-item__name";
        const ITEM_BADGE_CLASS = "data-list-item__badge";
        const ITEM_ID_ATTRIBUTE = "data-list-item-id";
        const ITEM_ICON_CLASS = "data-list-item__icon";
        const ITEM_ICONS_CLASS = "data-list-item__icons";
        const FORM_ICONS_CLASS = "wpt-form-icons";
        const FORM_ICONS_RIGHT_CLASS = "wpt-form-icons--right";
        const FORM_ICONS_LEFT_CLASS = "wpt-form-icons--left";
        const ITEM_ACTIVE_CLASS = "data-list-item--active";
        class ComponentDataList extends Widgets.ComponentBaseClass {
            constructor(core, container, parent, config) {
                super(core, container, parent);
                this._isReady = null;
                this._isWaitingDisplayData = null;
                this._componentDiv = null;
                this._currentListData = null;
                this._config = null;
                this._selectItemCallback = null;
                this._sublistIconOpened = null;
                this._sublistIconClosed = null;
                this.displayData = (data) => {
                    this._log.info("DataListComponent.displayData()");
                    this._currentListData = data;
                    if (this._isReady)
                        this._displayData();
                    else
                        this._isWaitingDisplayData = true;
                };
                this.clearList = () => {
                    this._log.info("DataListComponent.clearList()");
                    if (!this._isReady)
                        return;
                    this._currentListData = null;
                    this._componentDiv.innerHTML = "";
                };
                this.clearItemSelection = () => {
                    this._log.info("DataListComponent.clearItemSelection()");
                    // ignore if not ready
                    if (!this._isReady)
                        return;
                    let selectedItems = this._componentDiv.querySelectorAll('.' + ITEM_CLASS + '.' + Widgets.WIDGET_SELECTED_CLASS);
                    selectedItems.forEach(item => {
                        item.classList.remove(Widgets.WIDGET_SELECTED_CLASS);
                    });
                };
                this.selectItemAndClearIfFound = (id) => {
                    this._log.info("DataListComponent.selectItemAndClearIfFound()");
                    // ignore if not ready
                    if (!this._isReady)
                        return;
                    let item = this._componentDiv.querySelector('.' + ITEM_CLASS + '[' + ITEM_ID_ATTRIBUTE + '="' + id + '"]');
                    if (item) {
                        this.clearItemSelection();
                        item.classList.add(Widgets.WIDGET_SELECTED_CLASS);
                    }
                };
                this.selectItem = (id) => {
                    this._log.info("DataListComponent.selectItem()");
                    // ignore if not ready
                    if (!this._isReady)
                        return;
                    let item = this._componentDiv.querySelector('.' + ITEM_CLASS + '[' + ITEM_ID_ATTRIBUTE + '="' + id + '"]');
                    item === null || item === void 0 ? void 0 : item.classList.add(Widgets.WIDGET_SELECTED_CLASS);
                };
                this.deSelectItem = (id) => {
                    this._log.info("DataListComponent.deSelectItem()");
                    // ignore if not ready
                    if (!this._isReady)
                        return;
                    let item = this._componentDiv.querySelector('.' + ITEM_CLASS + '[' + ITEM_ID_ATTRIBUTE + '="' + id + '"]');
                    item === null || item === void 0 ? void 0 : item.classList.remove(Widgets.WIDGET_SELECTED_CLASS);
                };
                this.filterItems = (search) => {
                    this._log.info("DataListComponent.filterItems()");
                    // ignore if not ready
                    if (!this._isReady)
                        return;
                    let items = this._componentDiv.querySelectorAll('.' + ITEM_CLASS);
                    items.forEach(item => {
                        if (item.classList.contains(Widgets.WIDGET_SELECTED_CLASS) || item.innerText.toLowerCase().indexOf(search.toLowerCase()) > -1) {
                            item.style.display = "";
                        }
                        else {
                            item.style.display = "none";
                        }
                    });
                };
                this.clearActiveItem = () => {
                    this._log.info("DataListComponent.clearActiveItem()");
                    // ignore if not ready
                    if (!this._isReady)
                        return;
                    let activeItems = this._componentDiv.querySelectorAll('.' + ITEM_CLASS + '.' + ITEM_ACTIVE_CLASS);
                    activeItems.forEach(item => {
                        item.classList.remove(ITEM_ACTIVE_CLASS);
                    });
                };
                this.setActiveItem = (index) => {
                    this._log.info("DataListComponent.setActiveItem()");
                    // ignore if not ready
                    if (!this._isReady)
                        return null;
                    this.clearActiveItem();
                    let visibleItems = this._componentDiv.querySelectorAll('.' + ITEM_CLASS + ':not([style*="display: none"])');
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking at " + visibleItems.length + " visible items");
                    }
                    let actualIndex = index;
                    if (index >= visibleItems.length) {
                        actualIndex = 0;
                    }
                    if (index < 0) {
                        actualIndex = visibleItems.length - 1;
                    }
                    let activeItem = visibleItems[actualIndex];
                    activeItem.classList.add(ITEM_ACTIVE_CLASS);
                    return actualIndex;
                };
                this.getActiveItem = () => {
                    this._log.info("DataListComponent.getActiveItem()");
                    let activeItem = this._componentDiv.querySelector('.' + ITEM_CLASS + '.' + ITEM_ACTIVE_CLASS);
                    return activeItem;
                };
                this._present = () => {
                    this._log.info("DataListComponent._present()");
                    this._container.innerHTML = ComponentDataList.Html;
                    this._componentDiv = this._container.querySelector('.widget-component--data-list');
                    this._isReady = true;
                    if (this._isWaitingDisplayData)
                        this._displayData();
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("DataListComponent._storeHtml()");
                    ComponentDataList.Html = htmlData;
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                };
                this._displayData = () => {
                    this._log.info("DataListComponent._displayData()");
                    this._componentDiv.innerHTML = "";
                    let fragement = document.createDocumentFragment();
                    let rootNode = document.createElement('ul');
                    fragement.appendChild(rootNode);
                    rootNode.classList.add(ROOT_CLASS);
                    if (this._currentListData) {
                        this._addContent(rootNode, this._currentListData.Items);
                    }
                    this._componentDiv.appendChild(fragement);
                };
                this._addContent = (parentNode, items) => {
                    this._log.info("DataListComponent._addContent()");
                    let length = items.length;
                    for (let i = 0; i < length; i++) {
                        let itemData = items[i];
                        let item = this._createItem(itemData);
                        parentNode.appendChild(item);
                    }
                };
                this._createItem = (data) => {
                    this._log.info("DataListComponent._createItem()");
                    let item = document.createElement('li');
                    if (data.IsHidden) {
                        item.classList.add(WPTNamespace.HIDDEN_CLASS);
                    }
                    let itemDiv = document.createElement('div');
                    itemDiv.setAttribute(ITEM_ID_ATTRIBUTE, data.Id);
                    item.appendChild(itemDiv);
                    if (data.AdditionalClasses) {
                        itemDiv.classList.add(...data.AdditionalClasses);
                    }
                    if (data.PrefixIcons && data.PrefixIcons.length > 0) {
                        let prefixIconSpan = document.createElement('span');
                        prefixIconSpan.classList.add(ITEM_ICONS_CLASS, FORM_ICONS_CLASS, FORM_ICONS_LEFT_CLASS);
                        itemDiv.appendChild(prefixIconSpan);
                        data.PrefixIcons.forEach(icon => {
                            let iconSpan = document.createElement('span');
                            if (icon.Classes)
                                iconSpan.classList.add(...icon.Classes);
                            if (icon.Title)
                                iconSpan.setAttribute('title', icon.Title);
                            prefixIconSpan.appendChild(iconSpan);
                            if (icon.Callback) {
                                iconSpan.addEventListener('click', icon.Callback.bind(this, data.Id));
                            }
                        });
                    }
                    if (data.PrefixBadge) {
                        let prefixBadgeSpan = document.createElement('span');
                        prefixBadgeSpan.classList.add(ITEM_BADGE_CLASS);
                        prefixBadgeSpan.innerText = data.PrefixBadge;
                        itemDiv.appendChild(prefixBadgeSpan);
                    }
                    let nameSpan = document.createElement('span');
                    nameSpan.classList.add(ITEM_NAME_CLASS);
                    if (data.DisplayName === '' || data.DisplayName === ' ') {
                        nameSpan.innerHTML = '&nbsp;';
                    }
                    else {
                        nameSpan.innerText = data.DisplayName;
                    }
                    nameSpan.setAttribute('title', data.DisplayName);
                    itemDiv.appendChild(nameSpan);
                    if (data.SuffixIcons && data.SuffixIcons.length > 0) {
                        let suffixIconSpan = document.createElement('span');
                        suffixIconSpan.classList.add(ITEM_ICONS_CLASS, FORM_ICONS_CLASS, FORM_ICONS_RIGHT_CLASS);
                        itemDiv.appendChild(suffixIconSpan);
                        data.SuffixIcons.forEach(icon => {
                            let iconSpan = document.createElement('span');
                            if (icon.Classes)
                                iconSpan.classList.add(...icon.Classes);
                            if (icon.Title)
                                iconSpan.setAttribute('title', icon.Title);
                            suffixIconSpan.appendChild(iconSpan);
                            if (icon.Callback) {
                                iconSpan.addEventListener('click', icon.Callback.bind(this, data.Id));
                            }
                        });
                    }
                    if (data.SuffixBadge) {
                        let suffixBadgeSpan = document.createElement('span');
                        suffixBadgeSpan.classList.add(ITEM_BADGE_CLASS);
                        suffixBadgeSpan.innerText = data.SuffixBadge;
                        itemDiv.appendChild(suffixBadgeSpan);
                    }
                    if (data.Items) {
                        itemDiv.classList.add(SUBLIST_CLASS, 'widget__subheader');
                        if (data.SuffixBadge)
                            itemDiv.classList.add('widget__subheader--no-right-padding');
                        itemDiv.addEventListener('click', this._sublistClicked);
                        let iconSpan = document.createElement('span');
                        iconSpan.classList.add(ITEM_ICON_CLASS, ...this._sublistIconOpened);
                        itemDiv.insertBefore(iconSpan, nameSpan);
                        let childList = document.createElement('ul');
                        item.appendChild(childList);
                        this._addContent(childList, data.Items);
                    }
                    else {
                        itemDiv.classList.add(ITEM_CLASS);
                        itemDiv.addEventListener('click', this._itemClicked);
                    }
                    return item;
                };
                this._itemClicked = (event) => {
                    this._log.info("DataListComponent._itemClicked()");
                    let clickedItem = event.currentTarget;
                    let itemId = clickedItem.getAttribute(ITEM_ID_ATTRIBUTE);
                    // If the item isn't already selected, we are declaring it should be selected it now
                    let selected = clickedItem.classList.contains(Widgets.WIDGET_SELECTED_CLASS);
                    if (this._selectItemCallback) {
                        this._selectItemCallback(itemId, selected);
                    }
                };
                this._sublistClicked = (event) => {
                    this._log.info("DataListComponent._sublistClicked()");
                    let clickedItem = event.currentTarget;
                    let iconSpan = clickedItem.querySelector('.' + ITEM_ICON_CLASS);
                    let childList = clickedItem.parentElement.querySelector('ul');
                    if (childList.classList.contains(WPTNamespace.HIDDEN_CLASS)) {
                        this._core.Functions.showElement(childList);
                        iconSpan.classList.remove(...this._sublistIconClosed);
                        iconSpan.classList.add(...this._sublistIconOpened);
                    }
                    else {
                        this._core.Functions.hideElement(childList);
                        iconSpan.classList.remove(...this._sublistIconOpened);
                        iconSpan.classList.add(...this._sublistIconClosed);
                    }
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DataListComponent::constructor");
                if (config) {
                    this._config = config;
                }
                else {
                    this._config = {};
                }
                this._isReady = false;
                this._isWaitingDisplayData = false;
                if (this._config.hasOwnProperty('SelectItemCallback') && this._config.SelectItemCallback) {
                    this._selectItemCallback = this._config.SelectItemCallback;
                }
                if (this._config.hasOwnProperty('SublistIconOpened') && this._config.SublistIconOpened) {
                    this._sublistIconOpened = this._config.SublistIconOpened.split(" ");
                }
                else {
                    this._sublistIconOpened = DEFAULT_ICON_OPENED.split(" ");
                }
                if (this._config.hasOwnProperty('SublistIconClosed') && this._config.SublistIconClosed) {
                    this._sublistIconClosed = this._config.SublistIconClosed.split(" ");
                }
                else {
                    this._sublistIconClosed = DEFAULT_ICON_CLOSED.split(" ");
                }
                if (!ComponentDataList.Html) {
                    core.Loader.getVersionedHTML('widgets/components/dataList.html', this._storeHtml, core.Helper.missingHtmlErrorCallback);
                }
                else {
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                }
            }
            get SelectedItems() {
                let selections = [];
                if (this._isReady) {
                    let items = this._componentDiv.querySelectorAll('.' + ITEM_CLASS + '.' + Widgets.WIDGET_SELECTED_CLASS);
                    items.forEach(item => {
                        selections.push(item.getAttribute(ITEM_ID_ATTRIBUTE));
                    });
                }
                return selections;
            }
        }
        ComponentDataList.Html = null;
        Widgets.ComponentDataList = ComponentDataList;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
